import { render } from "./ItOpsKnowledgeLab.vue?vue&type=template&id=35157162"
import script from "./ItOpsKnowledgeLab.vue?vue&type=script&lang=js"
export * from "./ItOpsKnowledgeLab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__